import styled from 'styled-components';

export const VideoContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
VideoContainer.displayName = 'VideoContainer';

export const Video = styled.video`
  height: 100%;
  max-height: 100%;
  max-width: 100%;
`;
Video.displayName = 'Video';
